import useAppStore from '$appStore'
import { Country, Locale, PayrollSystem } from '$constants'
import { ActiveCompany } from '$models'
import { constructActiveCompanySettings } from '$utils'

type CompanySettings = {
  weekStartPreference: number
  dayStartPreference: string
  localePreference: Locale
  timeZonePreference: string
  payrollSystemPreference: PayrollSystem | null
  defaultFreightTaxRatePreference: string
  clockinRoundingPreference: string
  overrideSalesTaxRatePreference: boolean
  includePosClockinsPreference: boolean
  timeAllowsPaySummaryPreference: boolean
  hasPayrollPermission: boolean
  hasTimePermission: boolean
  hasManagerPermission: boolean
  hasSalaryPermission: boolean
  hasStockPermission: boolean
  countryPreference: Country
  timeRosterPublicToken: string | null
} & Omit<ActiveCompany, 'id' | 'preference' | 'hasPermission'>

export function useCompanySettings(): CompanySettings {
  const activeCompany = useAppStore((state) => state.activeCompany)

  const companySettings = constructActiveCompanySettings(activeCompany)

  return {
    address: activeCompany?.address,
    name: activeCompany?.name,
    tier: activeCompany?.tier,
    pos: activeCompany?.pos,
    invoiceEmail: activeCompany?.invoiceEmail,
    countryPreference: companySettings.countryPreference,
    weekStartPreference: companySettings.weekStartPreference,
    dayStartPreference: companySettings.dayStartPreference,
    localePreference: companySettings.localePreference,
    timeZonePreference: companySettings.timeZonePreference,
    payrollSystemPreference: companySettings.payrollSystemPreference,
    hasPayrollPermission: companySettings.hasPayrollPermission,
    hasManagerPermission: companySettings.hasManagerPermission,
    hasTimePermission: companySettings.hasTimePermission,
    hasSalaryPermission: companySettings.hasSalaryPermission,
    hasStockPermission: companySettings.hasStockPermission,
    defaultFreightTaxRatePreference:
      companySettings.defaultFreightTaxRatePreference,
    overrideSalesTaxRatePreference:
      companySettings.overrideSalesTaxRatePreference,
    includePosClockinsPreference: companySettings.includePosClockinsPreference,
    timeAllowsPaySummaryPreference:
      companySettings.timeAllowsPaySummaryPreference,
    clockinRoundingPreference: companySettings.clockinRoundingPreference,
    timeRosterPublicToken: companySettings.timeRosterPublicTokenPreference,
  }
}
